export default __webpack_public_path__ + "static/media/about_behind_the_science.e816dec0.jpg";